module.exports = __webpack_public_path__ + "static/media/V4-5.8967d731.png";